<template>
    <div class="background-slides-outer">
        <div class="background-slides">
            <div class="capper">
                <div class="capper-padded">
                    <!-- Swiper container -->
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in images" :key="index">
                                <img :src="`/assets/${item}`" alt="Background image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
export default {
    name: "BackgroundAssets",
    data() {
        return {
            images: ['bg4.jpg','bg1.jpg', 'bg3.jpg', 'bg2.jpg']
        };
    },
    mounted() {
        this.$nextTick(() => {
            let slider = new Swiper('.swiper-container', {
                modules: [Autoplay, EffectFade],
                init: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 3000,
                autoplay: {
                    delay: 3000
                },
                loop: true,
            });
            setTimeout(() => slider.init(), 100);
        })
    },
};
</script>

<style scoped lang="scss">
.background-slides {
    // Additional background-slides styling if needed
}

.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide img {
    width: 100%;
    height: auto;
    display: block;
}
</style>
